import { render, staticRenderFns } from "./NotPaid.vue?vue&type=template&id=43462872&scoped=true"
import script from "./NotPaid.vue?vue&type=script&lang=js"
export * from "./NotPaid.vue?vue&type=script&lang=js"
import style0 from "./NotPaid.vue?vue&type=style&index=0&id=43462872&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43462872",
  null
  
)

export default component.exports